import {Component, Input} from '@angular/core';
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'ui-molecule-spinner',
  standalone: true,
  imports: [
    MatProgressSpinner
  ],
  templateUrl: './ui-molecule-spinner.component.html'
})
export class UiMoleculeSpinnerComponent {

  @Input() color: 'primary' | 'accent' | 'warn' = 'accent';

}
